export default __webpack_public_path__ + "static/media/info14_datos_actualizados_modifica.b52a5809.png";